import React from 'react';
import {
  useDateHelper,
  Project,
  ProjectDetailsField,
} from 'nekst-api';
import {
  Text,
  useShowContextRequired
} from 'ui-builder';
import { UpdateFieldWrapper } from "./UpdateFieldWrapper";


export default function DateDetailsField(
  props: {
    sortName?: string,
    field: ProjectDetailsField,
  },
) {
  const context = useShowContextRequired<Project>();

  const details = context.data.statistic!.details;

  const dateHelper = useDateHelper();

  const fieldValueObj = details
    .find((d) => d.setting.id === props.field.id);

  const date = fieldValueObj?.value;

  const linkedTaskText = fieldValueObj?.linkedTask?.name
  ? ` (${fieldValueObj.linkedTask.name})`
  : '';

  let content;
  if (date) {
    const result = new Date(date);

    content =  (
      <Text>
        {fieldValueObj?.approximate ? 'approx. ' : ''}
        {dateHelper.toString(result)}
        {linkedTaskText}
      </Text>
    );
  } else {
    content = <Text>-{linkedTaskText}</Text>;
  }

  return (
    <UpdateFieldWrapper field={props.field}>
      {content}
    </UpdateFieldWrapper>
  )
}
